module.exports = __webpack_public_path__ + "img/eu_mask_en.5e9ff069.svg";